'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { type Tracker, TrackingAggregator } from '@qogita/tracking'
import { ReactNode } from 'react'
import { browserLogger } from 'src/core/logger/browser'

import { BrowserTrackerContext } from './browser-tracker-context'
import { gtagDestination } from './destinations/gtag'
import { linkedinDestination } from './destinations/linkedin'
import { segmentTrackingDestination } from './destinations/segment'
import { SellersBrowserTrackingEventList } from './types'

export function BrowserTrackerProvider({
  isTrackingEnabled,
  isAuthenticated,
  children,
}: {
  /**
   * If tracking is completely disabled we'll provide a tracking aggregator with no destinations
   * Effectively, `.track()` will do nothing.
   */
  isTrackingEnabled: boolean
  isAuthenticated: boolean
  children: ReactNode
}) {
  // We allow gtag and linkedin when unauthenticated, as we want to track sign-ups
  const destinations: Tracker<SellersBrowserTrackingEventList>[] = [
    gtagDestination,
    linkedinDestination,
  ]

  if (isAuthenticated) {
    // We only want to track authenticated users in Segment as it's too expensive to track unauthenticated users
    destinations.push(segmentTrackingDestination)
  }
  const browserTracker = new TrackingAggregator({
    destinations: isTrackingEnabled ? destinations : [],
    logger: browserLogger,
  })

  return (
    <BrowserTrackerContext.Provider value={browserTracker}>
      {children}
    </BrowserTrackerContext.Provider>
  )
}
